import { render, staticRenderFns } from "./adjust-credits-form.vue?vue&type=template&id=52901b08&scoped=true&"
import script from "./adjust-credits-form.vue?vue&type=script&lang=ts&"
export * from "./adjust-credits-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52901b08",
  null
  
)

export default component.exports